<template>
    <authenticated-layout>
        <v-card class="pa-6 mx-auto" max-width="600">
            <h1 class="py-2 mb-6 text-xl border-b">
                {{ $t("marginFactorsPanel.Margin factors panel") }}
            </h1>

            <MarginFactorsConfig
                :minimumCompanyMargins="minimumCompanyMargins"
                :baseMargins="baseMargins"
            />
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";
import MarginFactorsConfig from "@/Components/PriceConfigs/MarginFactorsConfig";

export default {
    components: { MarginFactorsConfig, AuthenticatedLayout },
    props: {
        minimumCompanyMargins: {
            type: Array,
            required: true,
        },
        baseMargins: {
            type: Array,
            required: true,
        },
    },
};
</script>
